import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=c0874c6e&scoped=true&"
var script = {}
import style0 from "./Features.vue?vue&type=style&index=0&id=c0874c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0874c6e",
  null
  
)

export default component.exports